var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { classNames, renderIcon } from '../../utils';
import { Badge } from '../badge/badge';
import Divider from '../divider/divider';
import Typography from '../typography/typography';
export default function SideMenuItem(_a) {
    var item = _a.item, onNavigation = _a.onNavigation;
    return (_jsx(Fragment, { children: _jsxs("div", __assign({ className: "group w-full items-center" }, { children: [item.showDivider && _jsx(Divider, { dividerType: "dashed" }), _jsxs("div", __assign({ onClick: function () { return onNavigation(item); }, className: classNames(item.current ? 'bg-primary text-white' : 'text-primary', 'flex h-full cursor-pointer flex-row items-center rounded-lg p-2.5 text-base font-medium') }, { children: [_jsx("div", __assign({ className: 'mr-4 w-1/12 items-center justify-center ' }, { children: item.icon && renderIcon(item.icon, 'flex-shrink-0 h-6 w-6') })), _jsx(Typography, { type: 'h4', color: item.current ? 'white' : 'textDark', text: item.name }), item.getNotificationCount && (_jsx("div", __assign({ className: "ml-auto" }, { children: item.getNotificationCount() > 0 && (_jsx(Badge, __assign({ className: "text-white" }, { children: item.getNotificationCount() }))) })))] }))] })) }, item.name));
}
//# sourceMappingURL=side-menu-item.js.map